import FlameIcon from 'assets/svgr-icons/Flame.svg'
import { REF_LINKS } from 'consts/refLinks'
import { redirectToProfileSubscriptionsPage } from 'utils'
import * as Styled from './styled'

interface IDiscountButtonProps {
  countdownLabel: string | null
  label?: string | null
}

const DiscountButton = ({ countdownLabel, label }: IDiscountButtonProps) => {
  return (
    <Styled.DiscountButton
      onClick={() =>
        redirectToProfileSubscriptionsPage(
          REF_LINKS.V_EDITOR_HEADER_DISCOUNT_BUTTON
        )
      }
    >
      {label && <span className="discount-label">{label}</span>}
      <FlameIcon />
      {countdownLabel && (
        <span className="discount-countdown">{countdownLabel}</span>
      )}
    </Styled.DiscountButton>
  )
}

export default DiscountButton
